import { toast } from 'sonner';

import {
  AVISO_DE_ACAO_INDISPONIVEL,
  AVISO_DE_CADASTRO_INDISPONIVEL,
} from '@/modulos/operacao/comum/cadastroIndisponivel';

/**
 * O aviso que uma tela mostra em vez de gravar, onde a API da ação ainda não
 * existe.
 *
 * O credenciamento público já grava de verdade (inscrição, rascunho,
 * acompanhamento e correção ligados à API desde o credenciamento ponta a
 * ponta). Hoje quem usa este aviso são os cartões de equipe do Portal do
 * Credenciado (`portal-credenciado/equipe/`), cujas ações não têm rota.
 *
 * Fingir sucesso — inclusive guardando em memória ou em `localStorage` — seria
 * pior que não ter a ação: quem usa sairia acreditando que ela foi feita.
 *
 * As duas constantes vêm de `modulos/operacao/comum/cadastroIndisponivel.ts` e
 * são reexportadas aqui para a tela ter um import só. Texto igual ao do resto do
 * sistema de propósito: dois avisos diferentes para a mesma situação fariam o
 * usuário achar que são problemas diferentes.
 *
 * `sonner`, nunca `useToast`: o `<Toaster />` montado em `App.tsx` é o de
 * `ui/base/sonner.tsx`. O do shadcn não está montado, e um `useToast()` daqui
 * simplesmente não apareceria na tela.
 */
export { AVISO_DE_ACAO_INDISPONIVEL, AVISO_DE_CADASTRO_INDISPONIVEL };

/** O formato dos avisos: título curto e uma frase dizendo o que esperar. */
export interface AvisoDeIndisponibilidade {
  title: string;
  description: string;
}

/**
 * Dispara o aviso de indisponibilidade.
 *
 * Sem argumento, usa o de cadastro — que é o caso da maioria dos botões destas
 * telas (enviar inscrição, salvar rascunho, anexar documento). Passe
 * `AVISO_DE_ACAO_INDISPONIVEL` no que muda a situação de uma inscrição já
 * enviada: reenviar para análise, reabrir, responder mensagem.
 */
export function avisarIndisponivel(
  aviso: AvisoDeIndisponibilidade = AVISO_DE_CADASTRO_INDISPONIVEL,
): void {
  toast(aviso.title, { description: aviso.description });
}
